module.exports = __webpack_public_path__ + "img/success-join.25a91bc6.png";